"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoRewards = void 0;
exports.promoRewards = [
    {
        id: '1',
        type: 'BONUS',
        bonusId: '1',
        bonus: '150',
    },
    {
        id: '2',
        type: 'BONUS',
        bonusId: '2',
        bonus: '50',
    },
    {
        id: '3',
        type: 'BONUS',
        bonusId: '3',
        bonus: '100',
    },
    {
        id: '4',
        type: 'BONUS',
        bonusId: '4',
        bonus: '75',
    },
    {
        id: '5',
        type: 'BONUS',
        bonusId: '5',
        bonus: '125',
    },
    {
        id: '6',
        type: 'BONUS',
        bonusId: '6',
        bonus: '50',
    },
    {
        id: '7',
        type: 'BONUS',
        bonusId: '7',
        bonus: '100',
    },
    {
        id: '8',
        type: 'BONUS',
        bonusId: '8',
        bonus: '75',
    },
];
